import React, { useEffect, useState } from 'react';
import './Solutions.css'; // you can style it here
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../../firebase'; // adjust based on your structure
import { motion, AnimatePresence } from 'framer-motion';

import factoids from '../../info/factoids';
import FactoidSection from '../../components/FactoidSection';

// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics 
// Optical Equipment

import { 
  MdOutlineHandshake, 
  MdOutlineArchitecture, 
  MdOutlinePrecisionManufacturing,
  MdOutlineFactCheck 
} from "react-icons/md";
import { FaHammer } from "react-icons/fa6";
import { IoChevronForward } from "react-icons/io5";


const PAGE_PASSWORD = "gofoton-ai"; // change this

const slides = [
  {
    video: "/videos/solutionAI.mp4",
    poster: "/videos/solutionAI.jpg",
    heading: "YOUR HOME FOR AI DATA CENTER FIBER INFRASTRUCTURE",
    subheading: "Every leap forward, every scalable solution, every AI-driven innovation relies on the power of fiber optics.",
    buttonLink: "/contact-us"
  }
];



const rows = [
  {
    need: "How do I add more density to support AI?",
    feature: "PEACOC® spreadable adapter technology allows for more terminations",
    benefit: "More capacity per RU",
  },
  {
    need: "How can I create higher-speed connections to support AI applications and demand?",
    feature:
      "Higher bandwidth transceivers, High-density, custom configurable patch panels, and fiber connections to support 800G, and 1.6T",
    benefit: "Scale without backbone replacement",
  },
  {
    need: "I don’t have enough staff on my team with fiber network expertise.",
    feature:
      "We can be an extension of your team. We offer turnkey solutions (products and services) and can manage your project fully",
    benefit: "Focus internal teams on core operations.",
  },
  {
    need: "I struggle with supply chain and long lead times.",
    feature:
      "Our modular solutions and own manufacturing and management in diverse locations, to better control inventory",
    benefit: "Projects stay on schedule.",
  },
  {
    need: "I have aggressive deadlines to turn up my data center on time and on budget.",
    feature: "Expertise and project management of mission-critical projects",
    benefit:
      "Prevent multimillion-dollar losses from downtime or missed go-lives.",
  },
  {
    need: "I spend too much time managing vendors.",
    feature:
      "Engineering, procurement, and installation, all with one vendor",
    benefit:
      "Reduce errors, delays, and finger-pointing. We assume accountability.",
  },
];

const data = [
    {
      title: "Scalable Low Voltage Cabling (LVC)",
      desc: "From design to delivery, Go!Foton takes full ownership of the connectivity lifecycle, eliminating risks of multi-vendor complexity.",
      bullets: ["Engineering & design expertise", "Certified installation teams", "Logistics & material supply", "One-stop accountability", "Better outcomes"],
      color: "#0056b3",
      image: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FLVC%20Services.jpeg?alt=media&token=2da2a14b-9f64-43cb-9e35-ae3f3759f311"
    },
    {
      title: "Innovative Products & Versatility",
      desc: "Most high-density systems force a trade-off between capacity and serviceability. Not Go!Foton. Solutions support maximum fiber counts.",
      bullets: ["PEACOC® innovation", "Modular patch panels & cassettes", "AI-Ready Designs (400G - 1.6T)", "Reliability by design"],
      color: "#008cba",
      image: "/images/title2.jpg"
    },
    {
      title: "In-House Global Manufacturing",
      desc: "Unlike vendors who outsource, Go!Foton owns and operates its own facilities, providing unmatched control over quality and lead time.",
      bullets: ["Lead-time certainty", "Customization at speed", "Consistent quality", "Global footprint"],
      color: "#00a388",
      image: "/images/careers/3.jpg"
    }
  ];

  const steps = [
    {
      icon: <MdOutlineHandshake size={40} />,
      title: "Customer Needs & Strategy",
      desc: "Engage with Go!Foton to define project requirements, timelines, and performance goals"
    },
    {
      icon: <MdOutlineArchitecture size={40} />,
      title: "Engineering & Design",
      desc: "Certified engineering partners deliver precise, future-ready designs"
    },
    {
      icon: <MdOutlinePrecisionManufacturing size={40} />,
      title: "Material Sourcing & Manufacturing",
      desc: "Go!Foton manufactures high-density fiber solutions with patented Spreadable Adapter Technology"
    },
    {
      icon: <FaHammer size={35} />,
      title: "Installation & Integration",
      desc: "Certified installation partners ensure flawless, on-time deployment"
    },
    {
      icon: <MdOutlineFactCheck size={40} />,
      title: "Testing, Handover & Ongoing Support",
      desc: "Comprehensive QA, documentation, and single-point accountability"
    }
  ];

const posts = [
  {
      id: "01",
      category: "Infrastructure",
      tags: ["AI"],
      title: "Connectivity Guide to AI Data Center Terminology",
      date: "04 / 21 / 2026",
      excerpt: "A glossary of terms to help demystify acronyms, terminology, and decode general AI data center language.",
      img: "/images/blog/aiTerminology.jpeg",
      url: "https://gofoton.com/connectivity-guide-to-ai-data-center-terminology"
    },
  {
      id: "02",
      category: "Infrastructure",
      tags: ["AI", "Data Centers"],
      title: "The Networking Skilled Labor Gap: The realities and remedies",
      date: "02 / 25 / 2026",
      excerpt: "In the last 2 years, just about every conversation I have regarding network infrastructure new builds and installations always lead to the same question, “Where are you finding quality technicians and engineers right now?”.",
      img: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FBlogSkilledLabor.jpeg?alt=media&token=a6258f5f-6e1c-4616-8f6c-8c39eb65776c",
      url: "https://gofoton.com/the-networking-skilled-labor-gap"
    },
    {
      id: "03",
      category: "Fiber Basics",
      tags: ["AI", "Data Centers", "Connectivity"],
      title: "Fiber Optic Basics in the Age of AI Data Centers",
      date: "09 / 12 / 2024",
      excerpt: "As data centers evolve to support new AI companies and AI-based applications, fiber optic connectivity has become crucial. These connections enable high bandwidth and low latency essential for cloud transfers.",
      img: "https://www.gofoton.com/images/services/image4.jpg",
      url: "https://www.gofoton.com/fiber-optic-basics-in-the-age-of-ai-datacenters"
    },
    // {
    //   id: "04",
    //   category: "Infrastructure",
    //   tags: ["Single-Mode", "Multi-Mode", "Hardware"],
    //   title: "The Importance of Fiber Density in AI Data Centers",
    //   date: "09 / 13 / 2024",
    //   excerpt: "Fiber optics serve as the backbone of modern networks, connecting critical equipment and software. In AI data centers, fiber-dense infrastructure is essential for supporting the high bandwidth, low-latency, and scalable data transmission these environments demand. ",
    //   img: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/productImages%2FEVA_16F-MMF_2x8_MPO-DXLCU_FA_with-cover.png?alt=media&token=1da6fccb-b00d-4ea1-a8c3-69984db328a3",
    //   url: "https://www.gofoton.com/the-importance-of-fiber-density-in-ai-data-centers/" 
    // }
  ];

function SolutionCentralOffice() {

  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');

  const [startIndex, setStartIndex] = useState(0);
  const [activeTab, setActiveTab] = useState(0);

  const [isMobile, setIsMobile] = useState(false);

  const [familyIndex, setFamilyIndex] = useState(0);
const [familySlidesPerView, setFamilySlidesPerView] = useState(3);

useEffect(() => {
  const updateFamilySlidesPerView = () => {
    if (window.innerWidth <= 768) {
      setFamilySlidesPerView(1);
    } else if (window.innerWidth <= 1100) {
      setFamilySlidesPerView(2);
    } else {
      setFamilySlidesPerView(3);
    }
  };

  updateFamilySlidesPerView();
  window.addEventListener("resize", updateFamilySlidesPerView);
  return () => window.removeEventListener("resize", updateFamilySlidesPerView);
}, []);


  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const next = () => {
    if (startIndex + 3 < topByFamily.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const prev = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  const facts = [
    { label: "Staff execution", value: 36, prefix: "", suffix: "%", key: "years" },
    { label: "Insufficient staff", value: 28, prefix: "", suffix: "%", key: "continents" },
    { label: "Incorrect procedures", value: 21, prefix: "", suffix: "%", key: "employees" },
  ];


const productFamilies = [
  'Fiber Cable Assemblies',
  'Cassettes',
  'Frames',
  'Fiber Panels',
  //'Fiber Splice Chassis'
];

    const [counts, setCounts] = useState({
      years: 0,
      continents: 0,
      employees: 0,
    });

      useEffect(() => {
        const animationFrames = {};
        const durations = 600; // in ms
    
        facts.forEach(fact => {
          const start = performance.now();
    
          const animate = now => {
            const progress = Math.min((now - start) / durations, 1);
            const currentValue = Math.floor(progress * fact.value);
    
            setCounts(prev => ({
              ...prev,
              [fact.key]: currentValue,
            }));
    
            if (progress < 1) {
              animationFrames[fact.key] = requestAnimationFrame(animate);
            }
          };
    
          animationFrames[fact.key] = requestAnimationFrame(animate);
        });
    
        return () => {
          Object.values(animationFrames).forEach(cancelAnimationFrame);
        };
      }, []);


const toSlug = str => str.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');

const topByFamily = [
  {
    family: 'Services',
    slug: '/services',
    topProduct: null
  },
  ...productFamilies.map(famName => {
    const matchingProducts = filteredProducts.filter(
      p => (p.productFamily || '').trim() === famName
    );
    if (matchingProducts.length === 0) return null;

    const topProduct = matchingProducts.reduce((best, current) =>
      Number(current.rank ?? Infinity) < Number(best.rank ?? Infinity) ? current : best
    );

    return {
      family: famName,
      slug: toSlug(famName),
      topProduct
    };
  }).filter(Boolean)
];


const familyMaxIndex = Math.max(topByFamily.length - familySlidesPerView, 0);

const nextFamily = () => {
  setFamilyIndex((prev) => Math.min(prev + 1, familyMaxIndex));
};

const prevFamily = () => {
  setFamilyIndex((prev) => Math.max(prev - 1, 0));
};

useEffect(() => {
  if (familyIndex > familyMaxIndex) {
    setFamilyIndex(familyMaxIndex);
  }
}, [familyIndex, familyMaxIndex]);

  const [industryFilter, setIndustryFilter] = useState('Central Office & Headends')


useEffect(() => {
  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const allProducts = querySnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');

    setProducts(allProducts);
    setFilteredProducts(allProducts); // Default to all
  };

  loadProducts();
}, []);

useEffect(() => {
  if (activeFilter === 'All') {
    setFilteredProducts(products);
  } else {
    setFilteredProducts(products.filter(p => p.productFamily === activeFilter));
  }
}, [activeFilter, products]);


  return (
    <div className="contact-page">
      <div
        className="single-marquee"
        style={
          isMobile
            ? {
                background: "linear-gradient(180deg, #1e1e1e, #3a3a3a)",
                height: "70vh",
              }
            : {}
        }
      >
        <div className="single-marquee-slide" style={{ height: "100%" }}>
          
          {/* Desktop video only */}
          {!isMobile && (
            <video
              disablePictureInPicture
              controlsList="nodownload nofullscreen noremoteplayback"
              src={slides[0].video}
              poster={slides[0].poster}
              autoPlay
              loop
              muted
              playsInline
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          )}

          <div
            className="single-overlay-content"
            style={
              isMobile
                ? {
                    position: "relative",
                    top: "auto",
                    left: "auto",
                    transform: "none",
                    textAlign: "center",
                    padding: "40px 20px",
                    maxWidth: "100%",
                  }
                : {}
            }
          >
            <h1 style={isMobile ? { textAlign: "center" } : {}}>
              {slides[0].heading}
            </h1>

            <p style={isMobile ? { textAlign: "center" } : {}}>
              {slides[0].subheading}
            </p>

            <a
              href="/support"
              className="cta-button"
              style={
                isMobile
                  ? {
                      display: "inline-block",
                      margin: "24px auto 0",
                    }
                  : {}
              }
            >
              Request a consult
            </a>
          </div>
        </div>
      </div>
    

      <svg className="section-divider-ai" viewBox="0 0 1440 150" preserveAspectRatio="none">
  <defs>
    <linearGradient id="hardWhiteSplit" x1="0" y1="0" x2="0" y2="1">
      <stop offset="50%" stopColor="white" stopOpacity="1" />
    </linearGradient>
  </defs>
  <path
    d="
      M0,150
      H1440
      V0
      Q720,75 0,0
      Z
    "
    fill="url(#hardWhiteSplit)"
  />
</svg>

      <div className="solutions-section-1">
        <div className="solutions-section-1-image-container">
          <img src="/images/solutions/ai2.jpg" alt="Central Office" />
        </div>

        <div className="solutions-section-1-text-container">
          <h2 className="solutions-section-1-subheading">AI moves fast: you need a partner who moves faster</h2>
          <p className="solution-section-1-description">

As AI accelerates across every industry, data centers are pushed to keep pace. GPU clusters and full-scale AI factories now depend on 400Gb, 800Gb, and even 1.6T speeds, denser optical interconnects, and advanced technologies such as Co-Packaged Optics.<br/><br/>

These unprecedented speeds, density, and advanced technologies demand more fiber in less space, higher‑quality connectivity, and lower latency. This keeps data flowing smoothly, preventing packet loss or retransmission that can disrupt AI performance.<br/><br/>

At the same time, the rapid growth is pushing AI data center builders and operators to maximize real estate, deploy more efficient infrastructure, and mobilize skilled teams to support high launch velocity.<br/><br/>

To keep pace, you need a partner who moves like AI itself and delivers a flexible, efficient, and streamlined experience. Go!Foton delivers exactly that: one partner, every step, no compromises.

          </p>
        </div>
      </div>

      <FactoidSection
        solution="ai"
        title="Can your business manage unprecedented AI innovation and explosive growth?"
        description="Opportunity is met with challenge. The push for higher density, faster DCI links, and flawless reliability collides with labor shortages, stressed supply chains, and rising project complexity. A vertically integrated, accountable partner that delivers full-stack AI solutions — hardware, optical interconnects, services, and lifecycle telemetry — to design, manufacture, and install AI-ready infrastructure with speed and confidence is your key to success."
      />


      <div className="solutions-section-checklist">
        <div className="solutions-section-checklist-left">
          
          <div className="solutions-section-checklist-image-wrapper" style={{justifyContent: 'flex-start', alignItems: "flex-start"}}>
            <img src="/images/solutions/ai.jpg" alt="AI" />
          </div>
        </div>

        <div className="solutions-section-checklist-right">
          <h2 className="solutions-section-checklist-heading">Networks aren’t one-size-fits-all. We tailor to your needs.</h2>
          <p className="solutions-section-checklist-description">Your complex projects deserve a partner that evolves with machine learning (ML) and data science workflows. Our turnkey, end-to-end approach simplifies complexity and accelerates deployment for training clusters, inference pods, and more. You can expect from Go!Foton:</p>
          
        </div>

        <ul className="solutions-section-checklist-points">
            <li>Customized, scalable solutions for rapid densification at 400G, 800G, or 1.6T and CPO-compatible architectures</li>
            <li>Fiber management leadership that maximizes density while preserving airflow for energy efficiency and electronics protection, ease of serviceability, and new protocol readiness</li>
            <li>Faster deployments with integrated, turnkey connectivity and technician expertise, eliminating multi-vendor handoffs and reducing packet loss risk</li>
            <li>Next-generation innovations, such as our patented PEACOC® spreadable adapter technology to solve very small form factor (VSFF) optical connector and fiber shuffle challenges</li>
            <li>Expert services in design, planning, and engineering to close labor gaps and accelerate launch velocity</li>
            <li>End-to-end project management that mobilizes skilled teams quickly for large-scale DCI and campus builds on time and on budget</li>
            <li>In-house manufacturing mitigates supply chain risk and provides lead-time certainty</li>
          </ul>
      </div>



          <div className="solutions-section-checklist" style={{ flexDirection: 'column'}}>

<center>

          <h2 className="solutions-section-1-subheading">Connectivity providers-as-usual won’t cut it</h2>
          <p className="solution-section-centeredText-description" style={{textAlign: 'center', marginTop: '10px'}}>Go!Foton delivers like AI:  driving transformation without friction. What sets us apart from other connectivity solution providers?</p>
   </center>

<div style={{ maxWidth: '1000px', margin: '40px auto', fontFamily: 'sans-serif', backgroundColor: '#f8f8f8', }}>
      {/* THE ROW: Flexbox ensures they are in a straight line */}
      <div style={{ display: 'flex', borderBottom: '2px solid #eee' }}>
        {data.map((item, idx) => (
          <div
            key={idx}
            onMouseEnter={() => setActiveTab(idx)}
            style={{
              flex: 1,
              padding: '20px',
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              borderBottom: activeTab === idx ? '4px solid #23B0BA' : '4px solid transparent',
              background: activeTab === idx ? '#f8f9fa' : 'white',
              fontWeight: activeTab === idx ? 'bold' : 'normal',
              color: activeTab === idx ? '#23B0BA' : '#555'
            }}
          >
            {item.title}
          </div>
        ))}
      </div>

      {/* CONTENT AREA */}
{/* CONTENT AREA */}
<div className="tabContentArea">
  <AnimatePresence mode="wait">
    <motion.div
      key={activeTab}
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      transition={{ duration: 0.3 }}
      className="tabContentInner"
    >
      {/* Left: Image */}
      <div
        className="tabContentImage"
        style={{
          backgroundImage: `url("${data[activeTab]?.image}")`,
        }}
      />

      {/* Right: Text & Bullets */}
      <div className="tabContentText">
        <p className="tabContentDesc">{data[activeTab]?.desc}</p>

        <div className="tabContentBullets">
          {(data[activeTab]?.bullets || []).map((bullet, i) => (
            <div key={i} className="tabBullet">
              <span className="tabBulletDot" />
              {bullet}
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  </AnimatePresence>
</div>

    </div>
    </div>

      <div className="solutions-section-centeredText" style={{ backgroundColor: '#f8f8f8', position: 'relative', marginTop: "-30px"}}>
        <div className="solutions-section-centeredText-text-container">
<h2 className="solutions-section-centeredText-subHeading">Our approach begins and ends with you</h2>



<div className="approach-steps">
  {steps.map((step, idx) => (
    <React.Fragment key={idx}>
      <div className="icon-item">
        <div style={{ color: "#555" }}>{step.icon}</div>
        <div>
          <p style={{ color: "#85246D", fontWeight: "bold", marginBottom: 6 }}>
            {step.title}
          </p>
          <p style={{ color: "#4D4D4F", lineHeight: 1.4, margin: 0 }}>
            {step.desc}
          </p>
        </div>
      </div>

      {idx !== steps.length - 1 && (
        <div className="approach-arrow" aria-hidden="true" style={{ marginTop: 20 }}>
          <IoChevronForward />
        </div>
      )}
    </React.Fragment>
  ))}
</div>


          </div>
          <div className="curved-divider-bottom" />

      </div>




 <section className="solution-products-section" style={{ backgroundColor: 'white'}}>
      <h2>Engineered for optimal AI experiences</h2>
      <p className="solution-products-section-description">Modular, AI-ready fiber systems and services that reduce latency, prevent retransmission, and future-proof your data center for large language model (LLM) training, inference, and predictive analytics.</p>

<div className="article-slider-container">
  {topByFamily.length > familySlidesPerView && (
    <button
      className={`chevron chevron-left ${familyIndex === 0 ? "disabled" : ""}`}
      onClick={prevFamily}
      disabled={familyIndex === 0}
    >
      &#10094;
    </button>
  )}

  <div className="article-slider-viewport">
    <div
      className="article-slider-track"
      style={{
        transform: `translateX(-${familyIndex * (100 / familySlidesPerView)}%)`,
        "--content-slides-per-view": familySlidesPerView,
      }}
    >
      {topByFamily.map((article, idx) => (
        <div className="article-slider-slide" key={idx}>
          <div className="image-slider-card">
            <div className="image-logo-wrapper">
              <img
                src={
                  article.topProduct
                    ? article.topProduct.image
                    : "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FAI%20Data%20Center%20Image%20(1).jpg?alt=media&token=367424a2-ef6c-4e88-a8dc-8ac186a99ac1"
                }
                alt="logo"
                className="image-logo"
              />
            </div>

            <h3>{article.family}</h3>

            <a
              className="cta-button"
              href={article.topProduct ? `/${article.slug}` : `/services`}
              style={{ textDecoration: "none" }}
            >
              View
            </a>
          </div>
        </div>
      ))}
    </div>
  </div>

  {topByFamily.length > familySlidesPerView && (
    <button
      className={`chevron chevron-right ${familyIndex === familyMaxIndex ? "disabled" : ""}`}
      onClick={nextFamily}
      disabled={familyIndex === familyMaxIndex}
    >
      &#10095;
    </button>
  )}
</div>
    


<div style={{ paddingRight: '2vw', marginTop: 150, paddingLeft: '2vw', alignItems: 'flex-start'}}>
          <h2 style={{ textAlign: 'left'}} className="solutions-section-checklist-heading">Here’s a look at how Go!Foton can solve some of your AI network challenges</h2>
         </div>

         <img
  src="/images/solutions/datacenterTable.png"
  alt="Datacenter Table"
  className="responsive-image-table"
/>


<div className="fb-table">
      <div className="fb-row fb-header">
        <div className="fb-cell fb-need-header">Does any of this sound like you?</div>
        <div className="fb-cell fb-feature-header">Our Feature</div>
        <div className="fb-cell fb-benefit-header">Your Benefit</div>
      </div>

      {rows.map((r, i) => (
        <div className="fb-row" key={i}>
          <div className="fb-cell fb-need">{r.need}</div>
          <div className="fb-cell fb-feature">{r.feature}</div>
          <div className="fb-cell fb-benefit">{r.benefit}</div>
        </div>
      ))}
    </div>

    </section>


<div className="blog-container">
  <center><h2 className="solutions-section-centeredText-subHeading" style={{ marginBottom: "60px"}}>Recent Blogs</h2></center>

                {/* <center><h2 style={{ textAlign: 'left'}} className="solutions-section-checklist-heading">Recent Blogs</h2></center> */}

      {posts.map((post) => (
        <div key={post.id} className="blog-post-wrapper">
          {/* Ghost Number Background */}
          {/* <div className="ghost-number">{post.id}</div> */}

          {/* Image */}
          <div className="blog-image-box">
            <img src={post.img} alt={post.title} />
          </div>

          {/* Content */}
          <div className="blog-content">
            <span className="category-label">{post.category}</span>
            <div className="tag-container">
              {post.tags.map(tag => (
                <span key={tag} className="pill-tag">{tag}</span>
              ))}
            </div>
            
            <h2 className="blog-title">{post.title}</h2>
            <p className="blog-excerpt">{post.excerpt}</p>

            <div className="blog-footer">
              <span className="blog-date">{post.date}</span>
              <a 
                href={post.url} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="read-story-btn"
              >
                Read Story
              </a>
            </div>
          </div>
        </div>
      ))}
  <center>
      <a className="cta-button"  href="/knowledge-center">SEE MORE BLOGS</a>
      </center>
    </div>


    {/* <section className="solution-products-section">
      <h2>Engineered for AI-optimized connectivity</h2>
      <p className="solution-products-section-description">Our fiber solutions deliver extended reach, ultra-low latency, and simplified interconnectivity, with customizable designs and intuitive, high-density fiber management that ensures scalable, long-term network optimization.</p>

<div className="filter-buttons">
  {['All', ...productFamilies].map((filter) => (
    <button
      key={filter}
      onClick={() => setActiveFilter(filter)}
      className={activeFilter === filter ? 'active' : ''}
    >
      {filter}
    </button>
  ))}
</div> */}


{/* <div className="products-grid">
  {filteredProducts.map(product => (
    <div key={product.id} className="product-card">
      {product.image ? (
        <img
          src={product.image}
          alt={product.product}
          style={{ width: "100%", height: 200, objectFit: "cover" }}
        />
      ) : (
        <div
          style={{
            width: "100%",
            height: 215,
            backgroundColor: "#ddd",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontStyle: "italic",
            color: "#666",
          }}
        >
          No Image Available
        </div>
      )}
      <h3>{product.product}</h3>
      <a href={`/${product.id}`} className="learn-more">Learn More</a>
    </div>
  ))}
</div> */}

    {/* </section> */}

        <div className="curved-footer-solutions">
        <div className="curved-top-overlay-solutions" style={{background: 'white'}}></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>
    </div>
  );
}

export default SolutionCentralOffice;
